<template>
  <de-layout-content>
    <div class="">
      <div class="alnCt mb10">
        <a-button type="primary" icon="plus" class="mr10" @click="handleAdd"> 添加成员 </a-button>
        <a-button type="primary" icon="upload" class="mr10" @click="importAction"> 导入成员 </a-button>
        <a-button type="primary" icon="setting" class="mr10" @click="changeStatus(1)"> 设置状态 </a-button>
        <a-button type="primary" icon="download" @click="memberExport"> 导出成员 </a-button>
      </div>
      <el-form :inline="true" ref="queryForm" :model="seekData" class="ant-advanced-search-form" size="mini">
        <el-form-item label="姓名">
          <el-input v-model="seekData.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号码">
          <el-input v-model="seekData.phone" placeholder="请输入联系电话"></el-input>
        </el-form-item>
        <el-form-item label="用户类型">
          <el-select v-model="seekData.type" placeholder="请选择用户类型">
            <el-option :label="item.value" :value="item.key" :key="index" v-for="(item, index) in rolesSelect"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所在机构">
          <el-select v-model="seekData.organizationId" placeholder="请选择所在机构">
            <el-option :label="item.name" :value="item.id" :key="index" v-for="(item, index) in orgList"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账号状态">
          <el-select v-model="seekData.status" placeholder="请选择账号状态">
            <el-option label="启用" :value="1"></el-option>
            <el-option label="禁用" :value="-1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属组别">
          <SelectGroup :tId="seekData.teamId" :gId="seekData.groupId" @change="selectGroupChange"></SelectGroup>
        </el-form-item>
        <el-form-item label="注册时间">
          <el-date-picker v-model="seekData.time" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="doSeek" icon="el-icon-search">查询</el-button>
          <el-button type="" @click="removeSeek" icon="el-icon-refresh" >重置</el-button>
        </el-form-item>
      </el-form>

      <!-- 数据列表 -->
      <el-table ref="table" border :data="list" style="width: 100%" v-loading="loading" element-loading-text="加载中"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column label="姓名" align="center" prop="name" width="150" fixed="left" />
        <el-table-column label="用户类型" align="center" prop="type" width="120">
          <template slot-scope="scope">
            <div>{{ userTypeFilter(scope.row.type) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="照片" align="center" prop="headImageUrl" width="150">
          <template slot-scope="scope">
            <el-image style="width: 100px; height: 100px" :src="scope.row.headImageUrl || defalutAvatar"
              :preview-src-list="[scope.row.headImageUrl || defalutAvatar]">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column label="手机号" align="center" prop="phone" width="150" />

        <el-table-column label="籍贯" align="center" prop="nativePlace" width="180">
<!--          <template slot-scope="scope">-->
<!--            <div>{{ getCityById(scope.row.nativePlace) }}</div>-->
<!--          </template>-->
        </el-table-column>

        <el-table-column label="性别" align="center" prop="sex">
          <template slot-scope="scope">
            <div>{{ scope.row.sex == 1 ? "男" : "女" }}</div>
          </template>
        </el-table-column>

        <el-table-column label="账号状态" align="center" prop="status">
          <template slot-scope="scope">
            <div>{{ scope.row.status == 1 ? "启用" : "禁用" }}</div>
          </template>
        </el-table-column>

        <el-table-column label="年龄" align="center" prop="age"> </el-table-column>
        <el-table-column label="身高(cm)" align="center" prop="height"> </el-table-column>
        <el-table-column label="体重(kg)" align="center" prop="weight"> </el-table-column>
        <el-table-column label="所在机构" align="center" prop="employerName" width="200"> </el-table-column>
        <el-table-column label="所属运动组" align="center" prop="groupName" width="200">
          <template slot-scope="scope">
            <div>{{ scope.row.teamName }}/{{ scope.row.groupName }}</div>
          </template>
        </el-table-column>
        <el-table-column label="注册时间" align="center" prop="createTime" width="180">
          <template slot-scope="scope">
            <div>
              {{ scope.row.createTime ? moment(scope.row.createTime).format("yyyy-MM-DD HH:mm:ss") : "" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="350">
          <template slot-scope="scope">
            <div class="">
              <el-button size="small" plain type="primary" @click="goInfo(scope.row)">详情</el-button>
              <el-button size="small" plain type="success" @click="goEdit(scope.row)">编辑</el-button>
              <el-button size="small" plain type="danger" @click="deleteUser(scope.row)">删除</el-button>
              <el-button size="small" plain type="primary" @click="setDepartmentHandle(scope.row)">修改组别</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <pagination :total="pagination.total" :page.sync="pagination.current" :limit.sync="pagination.pageSize"
        @pagination="getList" />


      <!-- 设置部门 -->
      <SetDepartmentDialog
        :visible.sync="departmentDialogVisible"
        :user-id="currentDepartmentUserId"
        :department-options="departmentOption"
        @success="handleDepartmentSuccess"
      />

      <!-- 弹框修改用户组别 -->
      <el-dialog :title="setGroupData.name + '- 修改组别'" :visible.sync="showChangeGroup" width="600px" append-to-body>
        <!-- <div class="wz-flex-row wz-align-center wz-mr-4 wz-mb-2">
          <div class="wz-text-right wz-mr-2" style="width: 110px">
            选择组别：
          </div>
          <SelectGroup
            :tId="setGroupData.userInfo.teamId"
            :gId="setGroupData.userInfo.groupId"
            @change="setGroupChange"
          ></SelectGroup>
        </div> -->
        <el-form :model="setGroupData" label-width="100px" class="demo-ruleForm">
          <el-form-item label="修改组别" class="isRequired">
            <SelectGroup :tId="setGroupData.userInfo.teamId" :gId="setGroupData.userInfo.groupId" @change="setGroupChange"></SelectGroup>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="showChangeGroup = false">取 消</el-button>
          <el-button type="primary" @click="doChangeGroup">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 弹框修改用户组别 -->
      <el-dialog title="设置状态" :visible.sync="showChangeStatus" width="600px" append-to-body>
        <a-form :model="setStatusData">
          <a-form-item label="选择状态">
            <a-radio-group v-model="setStatusData.status" :options="statusOptions">
            </a-radio-group>
          </a-form-item>
          <a-form-item label="备注">
            <a-textarea v-model="setStatusData.remark" placeholder="输入备注" show-count :rows="4" :maxlength="200" />
          </a-form-item>
        </a-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="showChangeStatus = false">取 消</el-button>
          <el-button type="primary" @click="doChangeStatus">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 弹框导入成员 -->
      <el-dialog title="导入成员" :visible.sync="popupShow" width="600px" append-to-body>
        <el-form ref="form" :model="popupForm">
          <el-form-item label="选择组别" class="isRequired">
            <SelectGroup :tId="popupForm.teamId" :gId="popupForm.groupId" @change="importSelect"></SelectGroup>
          </el-form-item>
          <el-form-item v-for="(item, index) in importList" :key="index">
            <div class="cell">
              <div class="cellLeft">
                <a-icon type="cloud-download" :style="{ fontSize: '48px', color: '#ADB0C3' }" />
              </div>
              <div class="cellRight">
                <div class="" style="font-size: 16px; font-weight: bold; color: #fff">
                  {{ item.name }}
                </div>
                <div class="" style="line-height: 26px;">{{ item.text }}</div>
                <div class="" v-if="index">
                  <a-upload list-type="picture" :customRequest="customRequest" :showUploadList="false"
                    accept=".xls,.xlsx">
                    <span style="color: #1890FF; cursor: pointer" v-if="popupForm.file">{{ popupForm.file.name }}</span>
                    <span style="color: #1890FF; cursor: pointer" v-else>{{ item.action }}</span>
                  </a-upload>
                </div>
                <div class="" v-else>
                  <span style="color: #1890FF; cursor: pointer" @click="dataOperation('download')">{{ item.action }}</span>
                </div>
              </div>
            </div>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="popupShow = false">取 消</el-button>
          <el-button type="primary" @click="popupFormConfirm">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </de-layout-content>
</template>
<script>
import moment from "moment";
import { message, Modal } from "ant-design-vue";
import axios from "axios";
import * as API_Member from "@/api/train/member";
import * as API_System from "@/api/train/system";
import SelectGroup from "../components/SelectGroup.vue";
import {getDepartmentList} from "@/api/member/member";
// import { tableDragable } from "@/utils/util"
import SetDepartmentDialog from "../components/SetDepartmentDialog.vue";

export default {
  components: {
    SelectGroup,
    SetDepartmentDialog
  },
  data() {
    return {
      popupShow: false,
      citys: [],
      list: [],
      loading: false,
      defalutAvatar: 'https://pc.yity.cn/img/logo.7b5378d6.png',
      seekData: {
        name: null, // 姓名
        phone: null, // 手机号码
        type: undefined, // 用户类型
        teamId: undefined, // 所属运动队
        groupId: undefined, // 所属运动组
        organizationId: undefined,
        time: [], // 注册时间
        start: null, // 注册时间-开始
        end: null, // 注册时间-结束
      },
      //数据分页参数
      pagination: {
        current: 1,
        pageSize: 10,
        total: 100,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "30", "40", "50"],
      },
      userType: [
        { id: null, title: "全部" },
        { id: 2, title: "运动员" },
        { id: 3, title: "教练员" },
        { id: 4, title: "科研医疗人员" },
        { id: 5, title: "队伍管理人员" },
      ],
      orgList: [],
      userTypeObj: {
        1: "管理员",
        2: "运动员",
        3: "教练员",
        4: "科研医疗人员",
        5: "队伍管理人员",
      },

      showChangeGroup: false, // 显示修改组别弹框
      setGroupData: {
        type: "",
        name: "",
        userInfo: {},
        tId: null,
        gId: null,
        ids: [],
      },
      showChangeStatus: false,
      setStatusData: {
        ids: [],
        status: 1, // 状态
        remark: null, // 备注
      },
      // 多选用户
      selectRow: [],
      statusOptions: [
        { label: "正常", value: 1 },
        { label: "停用", value: -1 },
      ],
      popupForm: {},
      // 导入成员
      importList: [
        {
          name: "下载数据模板",
          text: "请按照数据模板的格式准备导入数据，模板中的表头名称不可更改，表头行不能删除.",
          action: "下载模板",
        },
        {
          name: "上传填好的产品信息表",
          text: "文件后缀名必须为xls 或xlsx （即Excel格式）",
          action: "上传文件",
        },
      ],
      rolesSelect: [],
      currentDepartmentUserId: null,
      departmentDialogVisible: null
    };
  },
  mounted() {
    let { query } = this.$route
    // console.log(this.$store.state.user.user);
    // console.log(this.$store.state.user.roles);
    if (query.groupId) this.seekData.groupId = Number(query.groupId)
    if (query.teamId) this.seekData.teamId = Number(query.teamId)
    // this.tableDragable('table')
    // 获取城市列表
    this.getCitys();
    this.getOrgList()
    this.getList();
    this._allRoles()
    this._getDepartmentList()
  },
  methods: {
    moment,
    // tableDragable,

    _getDepartmentList() {
      getDepartmentList({}).then(res => {
        if (res.code == 200) {
          this.departmentOption = res.data
        }
      })
    },
    _allRoles() {
      API_System.roleTypes({}).then(res => {
        console.log(res);
        if (res.success) {
          this.rolesSelect = res.data
        }
      })
    },
    getCitys() {
      let url = `administrativeArea.json`;
      axios.get(url, {}, false, true).then((res) => {
        // console.log(res);
        this.citys = res.data || [];
      });
    },
    getOrgList() {
      API_Member.orgList({type: 2}).then((res) => {
        // console.log(res);
        this.orgList = res.data || []
      })
    },
    getCityById(code, arr = this.citys) {
      const findItem = arr.find((item) =>
        JSON.stringify(item).includes(`"code":"${code}"`),
      );
      // console.log(findItem);
      if (!findItem) return "";
      else if (findItem.code == code) {
        return findItem.name;
      } else {
        return findItem.name + "/" + this.getCityById(code, findItem.areaList);
      }
    },
    // 修改组别弹框
    changeGroup(type = 0, item) {
      if (type == 0) {
        this.showChangeGroup = false;
      }
      if (type == 1) {
        // 修改单个用户
        this.setGroupData.type = 1;
        this.setGroupData.userInfo = item;
        this.setGroupData.name = item.name;
        this.showChangeGroup = true;
      }
      if (type == 2) {
        // 批量修改
        if (this.selectRow.length <= 0) {
          message.error("请选择要操作的成员！");
        } else {
          let name = "";
          let ids = [];
          this.selectRow.forEach((key) => {
            name += name ? "," + this.list[key].name : this.list[key].name;
            ids.push(this.list[key].id);
          });

          this.setGroupData.type = 1;
          this.setGroupData.name = name;
          this.setGroupData.ids = ids;

          this.showChangeGroup = true;
        }
      }
    },
    // 设置状态弹框
    changeStatus(type = 0) {
      if (type == 0) {
        this.showChangeStatus = false;
      } else {
        // 批量修改
        if (this.selectRow.length <= 0) {
          this.$message.error("请选择要操作的成员！");
        } else {
          let ids = [];
          ids = this.selectRow.map((item) => {
            return item.id;
          });
          this.setStatusData.ids = ids;
          this.showChangeStatus = true;
        }
      }
    },
    // 跳转详情
    goInfo(item) {
      this.$router.push(
        `/sportCenter/member/info?id=${item.id}&type=${item.type}`,
      );
    },
    // 跳转编辑
    goEdit(item) {
      this.$router.push(
        `/sportCenter/member/edit?id=${item.id}&type=${item.type}`,
      );
    },
    setDepartmentHandle(row){
      this.currentDepartmentUserId = row.id;
      this.departmentDialogVisible = true;
    },
    // 选择项改变
    tableRowChange(e) {
      // console.log(e);
      this.selectRow = e;
    },
    handleSelectionChange(val) {
      // console.log(val);
      this.selectRow = val;
    },
    // 确定修改组别
    doChangeGroup() {
      this.changeGroup(0);

      console.log(this.setGroupData);
      let params = {
        usersGroupList:[{
          organizationId: this.setGroupData.oId || this.setGroupData.userInfo.organizationId,
          teamId: this.setGroupData.tId || this.setGroupData.userInfo.teamId,
          groupId: this.setGroupData.gId || this.setGroupData.userInfo.groupId,
        }]
      };
      if (this.setGroupData.type == 1) {
        params.id = this.setGroupData.userInfo.id;
      } else {
        params.ids = this.setGroupData.ids;
      }
      // API_Member.setGroup(params).then((res) => {
      //   if (res.code == 200) {
      //     message.success("修改组别成功！");
      //     this.pagination.current = 1;
      //     this.getList();
      //   }
      // });
    },
    handleDepartmentSuccess() {
      this.pagination.current = 1;
      this.getList();
    },
    // 确定修改状态
    doChangeStatus() {
      this.changeStatus(0);
      let params = {
        remark: this.setStatusData.remark,
        status: this.setStatusData.status,
        ids: this.setStatusData.ids,
      };
      API_Member.setStatus(params).then((res) => {
        if (res.code == 200) {
          message.success("修改状态成功！");
          this.pagination.current = 1;
          this.getList();
        }
      });
    },
    // 运动队改变
    selectGroupChange(res) {
      // console.log(res);
      this.seekData.teamId = res.tId;
      this.seekData.groupId = res.gId;
    },
    // 修改用户组别
    setGroupChange(res) {
      // console.log(res);
      this.setGroupData.tId = res.tId;
      this.setGroupData.gId = res.gId;
    },
    importSelect(res) {
      this.popupForm.teamId = res.tId;
      this.popupForm.groupId = res.gId;
    },
    importAction() {
      this.popupShow = true;
    },
    // 切换页数
    tableChange(e) {
      this.pagination.current = e.current;
      this.getList();
    },
    // 点击搜索
    doSeek() {
      if (this.seekData.time.length > 0) {
        this.seekData.start = moment(this.seekData.time[0]).valueOf();
        this.seekData.end = moment(this.seekData.time[1]).valueOf();
      }
      this.pagination.current = 1;
      this.getList();
    },
    // 重置
    removeSeek() {
      this.$refs["queryForm"].resetFields();
      Object.keys(this.seekData).forEach((key) => {
        if (key != "time") {
          this.seekData[key] = null;
        } else {
          this.seekData[key] = [];
        }
      });
      // console.log(this.seekData);
      this.pagination.current = 1;
      this.getList();
    },
    // 获取列表
    getList() {
      let params = {
        approvalStatus: 2,
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        ...this.seekData,
      };
      // console.log(params);
      this.loading = true
      API_Member.getMemberList(params).then((res) => {
        // console.log(res);
        if (res.code == 200) {
          this.loading = false
          this.list = res.data.list;
          this.pagination.total = res.data.total;
        }
      });
    },
    // 删除用户
    deleteUser(info) {
      Modal.confirm({
        title: "删除用户",
        content: `是否删除${info.name}？`,
        cancelText: "取消",
        okText: "删除",
        onOk: async () => {
          console.log("点击确定");
          this._delUser(info.id);
        },
      });
    },
    _delUser(id) {
      API_Member.memberDel({ ids: [id] }).then((res) => {
        // console.log(res);
        if (res.code == 200) {
          message.success("删除成功！");
          this.pagination.current = 1;
          this.getList();
        }
      });
    },
    customRequest(file) {
      // this.popupForm.file = file.file;
      this.$set(this.popupForm, "file", file.file);
    },
    dataOperation(type, file) {
      let _that = this;
      let url = "";
      if (type == "download") {
        location.href =
          "https://sports-test-public.oss-cn-beijing.aliyuncs.com/public/templates/%E5%AF%BC%E5%85%A5%E6%88%90%E5%91%98.xlsx";
      }
      if (type == "export") {
        // console.log(11111);
        let param = _that.form;
        if (param.addDate.length > 0) {
          param["createTimeFrom"] = moment(param.addDate[0]).valueOf();
          param["createTimeTo"] = moment(param.addDate[1]).valueOf();
        }
        url = "/api/v1/device/download";
        _that.$axios.post(url, param, false, true).then((res) => {
          const blob = new Blob([res], { type: "application/vnd.ms-excel" }); // 构造⼀个blob对象来处理数据，并设置⽂件类型
          const href = URL.createObjectURL(blob); //创建新的URL表⽰指定的blob对象
          const a = document.createElement("a"); //创建a标签
          a.style.display = "none";
          a.href = href; // 指定下载链接
          a.download = `设备列表-${moment(new Date()).format("YYYYMMDD")}`; //指定下载⽂件名
          a.click(); //触发下载
          URL.revokeObjectURL(a.href); //释放URL对象
        });
      }
    },
    popupFormConfirm() {
      if (!this.popupForm.teamId) {
        this.$message.error("请选择所属运动队");
        return;
      }
      if (!this.popupForm.groupId) {
        this.$message.error("请选择所属组别");
        return;
      }
      if (!this.popupForm.file) {
        this.$message.error("请上传文件");
        return;
      }
      let formData = new FormData();
      formData.append("file", this.popupForm.file);
      formData.append("teamId", this.popupForm.teamId);
      formData.append("groupId", this.popupForm.groupId);
      API_Member.memberImportUser(formData).then((res) => {
        console.log(res);
        if (res.code === 200) {
          message.success("操作成功");
          this.popupShow = false;
          this.removeSeek()
        } else {
          message.error("操作失败");
        }
      });
    },
    handleAdd() {
      this.$router.push("/sportCenter/member/add");
    },
    memberExport() {
      API_Member.memberExport(this.seekData).then((res) => {
        const blob = new Blob([res], { type: "application/vnd.ms-excel" });
        const link = document.createElement("a");
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.download = `成员管理` + new Date().getTime() + `.xlsx`; // 下载的文件名
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
    userTypeFilter(userType) {
      let typeObj = this.rolesSelect.find(role => role.key == userType)
      return typeObj ? typeObj.value : '-'
    },
  },
};
</script>
<style scoped lang="less">
@import "/src/styles/common/common.less";
// ::v-deep .el-table__fixed {
//   background-color: #fff !important;
// }
.cell {
  display: flex;
  background-color: #282F54;

  .cellLeft {
    width: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    background-color: #333B69;
  }

  .cellRight {
    padding: 10px 18px;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
}
</style>
